import Select from "../Inputs/Select";
import Input from "../Inputs/Input";
import { useState } from "react";
import { Paydown, Person, ScenarioSettings } from "src/types";
import StartEndSelect from "./StartEndSelect";

interface Props {
  paydown: Paydown;
  people: Person[];
  settings: ScenarioSettings;
  setIncome: (income: Paydown) => void;
}

const BasicAnnuity = ({ people, paydown, setIncome, settings }: Props) => {
  const options = [...people] as any[];
  if (people.length == 2) {
    options.push({ name: "Joint", id: -1 });
  }

  const interest = paydown.interestRate / 100;
  let amount =
    (paydown.total * interest) / (1 - Math.pow(1 + interest, -paydown.length));

  if (paydown.paymentInYear === "beginning") {
    amount = amount / (1 + interest);
  }
  const [resultType, setResultType] = useState("yearly");
  const factor = resultType === "monthly" ? 12 : 1;
  const result =
    Number.isNaN(amount) || amount == Infinity
      ? 0
      : Math.round(amount / factor);

  return (
    <div className="flex flex-col gap-4">
      {people.length > 1 && (
        <Select
          options={options}
          width="w-64!"
          selected={
            paydown.personId == -1
              ? { name: "Joint", id: -1 }
              : people[paydown.personId]
          }
          // setSelected={(i) => setIncome({ ...paydown, personId: i.id })}
          //
          setSelected={(i) => {
            let newIncome = {
              ...paydown,
              personId: i.id,
            };
            if (
              ["age", "death", "retirement"].includes(paydown.start.type) &&
              i.id !== -1
            ) {
              newIncome.start = { ...paydown.start, personId: i.id } as any;
            }
            setIncome(newIncome);
          }}
          label="Person"
        />
      )}
      <Input
        label="Title"
        subtype="text"
        width="w-64!"
        size="income"
        value={paydown.name}
        setValue={(name) => setIncome({ ...paydown, name })}
      />
      <Input
        label="Principal"
        subtype="money"
        width="w-64!"
        size="income"
        value={paydown.total}
        tooltip="The total principal amount to be paid down"
        setValue={(name) => setIncome({ ...paydown, total: name })}
      />
      <Input
        label="Interest Rate"
        subtype="percent"
        width="w-64!"
        size="income"
        tooltip="The interest rate of the paydown"
        value={paydown.interestRate}
        setValue={(name) => setIncome({ ...paydown, interestRate: name })}
      />
      <Select
        label="Timing"
        width="w-64!"
        options={[
          { id: "beginning", name: "Beginning" },
          { id: "end", name: "End" },
        ]}
        selected={{
          id: paydown.paymentInYear,
          name: (paydown.paymentInYear as any)?.capitalize(),
        }}
        setSelected={(i) => setIncome({ ...paydown, paymentInYear: i.id })}
      />

      <StartEndSelect
        label="Start"
        shownOptions={[
          ["already-receiving"],
          ["calendar-year"],
          ["#-of-years"],
          ...people.map((p) => ["age", p.id] as any),
          ...people.map((p) => ["retirement", p.id] as any),
          ...people.map((p) => ["death", p.id] as any),
        ]}
        settings={settings}
        value={paydown.start}
        setValue={(start) => setIncome({ ...paydown, start })}
      />
      <Input
        label="Length (years)"
        subtype="number"
        width="w-64!"
        size="income"
        tooltip="How many years (e.g., 15) will the paydown last"
        value={paydown.length}
        setValue={(name) =>
          setIncome({
            ...paydown,
            length: name,
          })
        }
      />
      <Input
        label="Calculated Payment"
        subtype="mo/yr"
        width="w-64!"
        size="income"
        disabled
        value={{ value: result, type: resultType }}
        setValue={({ type }) => setResultType(type)}
      />
      <Select
        options={[
          { name: "Taxable", id: "Taxable" },
          { name: "Tax-Deferred", id: "Tax-Deferred" },
          { name: "Tax-Free", id: "Tax-Free" },
        ]}
        selected={{
          name: paydown.taxType,
          id: paydown.taxType,
        }}
        width="w-64!"
        setSelected={(i) => setIncome({ ...paydown, taxType: i.id })}
        label="Tax Status"
      />
    </div>
  );
};

export default BasicAnnuity;
